import React, { useState } from "react";
import imgGizi1 from "../../../assets/img_major04_1.jpg";
import imgGizi2 from "../../../assets/img_major04_2.jpg";
import imgGizi3 from "../../../assets/img_major04_3.jpg";

const MajorTab4 = props => {
    return (
        <>
            {/* 기지국/중계기 운용관리 */}
            <div className="tab-cont">
                <h2 className="major-in-h2">
                    BUSINESS <em>사업소개</em>
                </h2>
                <p className="major-sbj">{props.title}</p>
                <div className="person-gray-wrap gray-back-bg">
                    <div className="major-img-wrap">
                        <ul>
                            <li>
                                <img src={imgGizi1} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi2} alt="이미지" />
                            </li>
                            <li>
                                <img src={imgGizi3} alt="이미지" />
                            </li>
                        </ul>
                    </div>
                    <div className="mojor-business-wrap">
                        {/* <p className="cate">주요사업 업무</p> */}
                        <ul className="list">
                            <li className="hoverWraps">
                                <p className="hoverText">AI Virtual Fence</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- AI기술 기반 AI Virtual Fence 솔루션 구축 및 유지보수</p>
                                        <p>- 통합모니터링시스템 구축 실시간 이벤트 관리</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">AI Care 서비스 사업</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- LTE통신 기반 IP 스피커 납품/설치, 24시간 동작 관제 및 모니터링</p>
                                        <p>- 독거노인 및 장애우 대상 응급상황, 인지장애, 건강관리 등 조기대응</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">LTE-R</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- 철도통합무선망 설계/구축/운영 프로젝트 관리</p>
                                        <p>- DU/RRU, Access EMS 교육 훈련</p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">RTK 기준국 구축 사업</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- GPS EMI 측정 및 RTK 기준국 구축을 위한 상세설계</p>
                                        <p>- RTK기준국 구축 및 운용 유지보수 </p>
                                    </div>
                                </div>
                            </li>
                            <li className="hoverWraps">
                                <p className="hoverText">전자파 측정</p>
                                <div className="hoverNextContents">
                                    <div className="inner">
                                        <p>- 상용망/재난안전통신망/5G 특화망 무선국 전자파 강도 측정</p>
                                        <p>- 전자파 민원응대 현장 측정 서비스 제공</p>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                    {/* <p className="mojor-text">이동국(가입자단말기)과 이동전화 교환국 사이에 위치하여 이동국과의 무선전송과 교환국의 요청 있을 경우 통화중인 이동국의 신호강도를 측정하여 제공함으로써 이동전화 교환국이 이동국의 이동상황을 파악하는데 필요한 정보를 제공합니다.</p>

                    <p className="major-sbj">기지국</p>
                    <p className="mojor-text">기지국은 기저대역 신호처리, 유무선 변환 및 무선신호의 송수신 등을 수행하여 가입자 단말기와 CAI(COMMON AIR INTERFACE)로 직접 연결되는 망 종단장치입니다.</p> */}
                </div>
            </div>
        </>
    );
};

export default MajorTab4;
